// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { Subscription } from "le-coffre-resources/dist/Admin";
import type { QueryPayload, RequestOptions } from "../../../types";
import type { IPostSubscriptionsParams, IPutSubscriptionsParams } from "./Subscriptions";
import {
	createSubscriptionsGetMethod,
	createSubscriptionsLifecyclePostMethod,
	createSubscriptionsPostMethod,
	createSubscriptionsPutMethod,
} from "./helpers/subscriptionsMethodsHelpers";

interface SubscriptionsInstance {
	get(q?: QueryPayload, options?: RequestOptions): Promise<Subscription[]>;
	post(body: IPostSubscriptionsParams): Promise<unknown>;
	put(uid: string, body: IPutSubscriptionsParams): Promise<unknown>;
	cancelAtPeriodEnd(uid: string): Promise<Subscription>;
	reactivateAtPeriodEnd(uid: string): Promise<Subscription>;
}

let instance: SubscriptionsInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createSubscriptions(): SubscriptionsInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}
	const baseUrl = baseAdminInstance.namespaceUrl.concat("/subscriptions");
	return {
		get: createSubscriptionsGetMethod(baseAdminInstance, baseUrl),
		post: createSubscriptionsPostMethod(baseAdminInstance, baseUrl),
		put: createSubscriptionsPutMethod(baseAdminInstance, baseUrl),
		cancelAtPeriodEnd: createSubscriptionsLifecyclePostMethod(baseAdminInstance, baseUrl, "cancel"),
		reactivateAtPeriodEnd: createSubscriptionsLifecyclePostMethod(baseAdminInstance, baseUrl, "reactivate"),
	};
}

export function getSubscriptionsInstance(): SubscriptionsInstance {
	if (!instance) {
		instance = createSubscriptions();
	}
	return instance;
}
